<script>
    export let inactive = false;
</script>

<div class:inactive>
  <slot />
</div>

<style lang="scss">
    div {
        padding: 1rem;
        margin: 0.5rem;
        box-shadow: rgba(0, 0, 0, 0.16) 0 0.25rem 0.5rem;

        &.inactive {
            opacity: 0.5;
        }
    }
</style>
